<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>

      <b-form-group :label="$t('gateways.timezone')"
                    :state="validateState('timezone')">
        <multiselect v-model="form.timezone"
                     :options="timezoneList"
                     :allowEmpty="false"
                     :show-labels="false"
                     :searchable="true"
                     :placeholder="$t('gateways.timezone')"
                     :show-no-results="false" />
      </b-form-group>

      <b-form-group :label="$t('gateways.pools')"
                    class="mb-0">
      </b-form-group>
      <div v-for="(pl,index) in form.pools"
           :key="index">
        <div class="row mb-3">
          <div class="col-10">
            <b-form-input :id="`${index}-pKey`"
                          v-model="form.pools[index]"
                          :placeholder="$t('gateways.enterDomain')"></b-form-input>
          </div>
          <div class="col-2">
            <b-dropdown variant="success"
                        class="btn-icon more-dropdown"
                        right>
              <template v-slot:button-content><i class="fas fa-cog p-0"></i></i>
              </template>
              <b-dropdown-item @click="addNewPoolItem()">{{$t('global.addNew')}}</b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item @click="removePoolItem(index)"
                               class="text-danger">{{$t('global.delete')}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>

    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
var moment = require('moment-timezone')
 
export default {
  name: 'GatewayNTPCreate',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    gatewayId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      form: {
        timezone: '',
        pools: [],
      },
      timezoneList: '',
      pools: [],
    }
  },
  validations: {
    form: {
      timezone: {
        required,
      },
    },
  },
  created() {
    this.timezoneList = moment.tz.names()
    this.getNtpDetail()
  },
  methods: {
    getNtpDetail() {
      this.form.pools = []
      this.addNewPoolItem()
      ApiService.get(`packetbender/netgateways/${this.gatewayId}/ntp`)
        .then(({ data }) => {
          this.form.timezone = data.timezone
          this.form.pools = data.pools
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    addNewPoolItem() {
      this.form.pools.push('')
    },
    removePoolItem(index) {
      this.form.pools.splice(index, 1)
      if (this.form.pools.length == 0) this.addNewPoolItem()
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        timezone: this.form.timezone,
        pools: this.form.pools.join(','),
      }

      ApiService.post(`packetbender/netgateways/${this.gatewayId}/ntp`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          // this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  }, 
}
</script>